export default "__VITE_ASSET__062eda4d__"